import { render } from "./WaitTimerOverlay.vue?vue&type=template&id=3d6c8884"
import script from "./WaitTimerOverlay.vue?vue&type=script&lang=js"
export * from "./WaitTimerOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__